"use strict";

import dispatcher from "./../dispatcher";
import {Singleton} from "vwa/flux";
import poiStore from "./pois";

const editedPOIStore = new Singleton();
export default editedPOIStore;

window.editedPOIStore = editedPOIStore;

dispatcher.on('editPOI', poiId => {
	editedPOIStore.set(poiId || null);
});

poiStore.on("update", poi => {	
	if (editedPOIStore.get() == poi._id)
		editedPOIStore.set(null);
});

poiStore.on("remove", pois => {
	pois.forEach(poi => {
		if (editedPOIStore.get() == poi._id)
			editedPOIStore.set(null);
	});
});


// WEBPACK FOOTER //
// ./src/store/editedPOI.js